import React from 'react';
import { GluteHero } from '../components/glute/GluteHero';
import { GluteProblem } from '../components/glute/GluteProblem';
import { GluteMechanism } from '../components/glute/GluteMechanism';
import { GlutePreview } from '../components/glute/GlutePreview';
import { GluteIncludes } from '../components/glute/GluteIncludes';
import { GluteAudience } from '../components/glute/GluteAudience';
import { GluteMethod } from '../components/glute/GluteMethod';
import { GluteTestimonials } from '../components/glute/GluteTestimonials';
import { GluteFaq } from '../components/glute/GluteFaq';
import { GluteOffer } from '../components/glute/GluteOffer';
import { GluteStickyCta } from '../components/glute/GluteStickyCta';
import { Footer } from '../components/Footer';
import { gluteLegalDocuments } from '../data/legal';
export function GluteLab() {
  return <div className="w-full bg-coal-deep font-sans" data-id="element-384" data-mp="1s5uos04ol4qf">
      <GluteHero data-id="element-385" data-mp="1o6lr4k6ismpl" />
      <main data-id="element-386" data-mp="1o50w6tgan1r7">
        <GluteProblem data-id="element-387" data-mp="1o5kgggtf228e" />
        <GluteMechanism data-id="element-388" data-mp="1o3zkcmrgeb8f" />
        <GlutePreview data-id="element-389" data-mp="2j98z35f2inbn" />
        <GluteIncludes data-id="element-390" data-mp="2j7xyfegx5vor" />
        <GluteMethod data-id="element-391" data-mp="2j8g1aty3785n" />
        <GluteTestimonials data-id="element-392" data-mp="2j74zgzo7cah6" />
        <GluteAudience data-id="element-393" data-mp="2o7kavloxb7wi" />
        <GluteFaq data-id="element-394" data-mp="2o70u48b0epk2" />
        <GluteOffer data-id="element-395" data-mp="2o6hif9bycxeh" />
      </main>
      <Footer brand="Glute Lab" variant="coal" documents={gluteLegalDocuments} disclaimer="Este material es educativo y de entrenamiento físico. No sustituye la evaluación ni el consejo de un profesional de la salud. Consulta a tu médico antes de comenzar cualquier programa de ejercicio. Los resultados varían según cada persona y su constancia." data-id="element-396" data-mp="2syskoiu60va7" />
      <div className="h-20 w-full bg-coal-deep" aria-hidden="true" data-id="element-397" data-mp="25b18rgcjek9g" />
      <GluteStickyCta data-id="element-398" data-mp="2a6q0wym88yvq" />
    </div>;
}